module.exports = __webpack_public_path__ + "statics/img/submit-success.97f3d360.png";